export default[
  '/publicPage/waybillPublish',
  '/publicPage/myWaybill',
  '/publicPage/receiptConfirmationNew'
  ]